import { Vector3 } from 'three';
import { sides, xyz } from '@/Interfaces/common';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { transformPositionBySide } from '@/lib/transformPositionBySide';
import { $ } from '@/Engine/state';

export function moveGroupToAnotherWall(group: RackModule[], newWallPointer: Vector3, side: sides) {
    const leftModule = group.sort(
        (prevModule: RackModule, nextModule: RackModule) => prevModule.position.x - nextModule.position.x)[0];
    const minX = leftModule.position.x;
    const pointer = new Vector3(...transformPositionBySide(
        new Vector3().set(newWallPointer.x, leftModule.model.position.y, newWallPointer.z),
        side,
        $.room,
    ));

    $.room.addToWall(leftModule.model, side);
    leftModule.position = pointer;
    // leftModule.setPositionWithShelves(pointer);

    let direction = 1;

    let wallEnd = false;
    if (minX < leftModule.position.x) {
        direction = -1;
        wallEnd = true;
    }
    const basePosition = new Vector3(
        leftModule.position.x + (wallEnd?-($.selectionBox.width+leftModule.width):leftModule.width/2),
        leftModule.position.y,
        leftModule.position.z);

    leftModule.position = basePosition.clone();
    // leftModule.setPositionWithShelves(basePosition.clone());


    group.forEach((module: RackModule)=>{
        if (leftModule.uuid !== module.uuid) {
            const deltaX = module.position.x - minX;
            $.room.addToWall(module.model, side);
            const newModulePosition = basePosition.clone().add(new Vector3(deltaX, 0,0));
            module.position = newModulePosition;
        }

        module.shelves.forEach((shelf)=> {
            $.room.addToWall(shelf.model, side);
            shelf.position = module.position.clone();
            // shelf.computeObb();
        });
        const rail = module.railGroup;
        if (rail?.model)
            $.room.addToWall(rail.model, side);
        module.computeObb();
        // !movedModulePosition && (movedModulePosition = module.position.clone());
    });
}
